document.addEventListener("DOMContentLoaded", function () {
  function syncDiscountedPrice() {
    const $progress = $('.cart-promotion-message__progress');
    const threshold = $progress.data("promotion-threshold");
    const targetNode = document.querySelector(".discount-code-input-wrapper");
    const dcodeValue =  $(targetNode).find('span.dcode-total-value').text();
    const $subTotal = $(".cart-promotion-message__progress-bar-container .sub-total");

    if (dcodeValue) {
      $subTotal.text(`HK$${dcodeValue}`);

      const percentage = Number(dcodeValue) * 100 / threshold;
      $progress.width(`${percentage}%`);

      if (percentage > 100) {
        $subTotal.css({ display: "none" });
      } else {
        $subTotal.css({ display: "block" });
        $subTotal.css({ left: `calc(${percentage}% - 64px)` });
      }
    } else {
      $subTotal.text(`HK$${$subTotal.data('subtotal')}`)

      const percentage = Number($subTotal.data('subtotal')) * 100 / threshold;
      $progress.width(`${percentage}%`);

      if (percentage > 100) {
        $subTotal.css({ display: "none" });
      } else {
        $subTotal.css({ display: "block" });
        $subTotal.css({ left: `calc(${percentage}% - 64px)` });
      }
    }
  }

  setInterval(() => {
    syncDiscountedPrice()
  }, 2000);
});
